import {
  GET_ALL_BLOGS,
  ADD_NEW_BLOG,
  REMOVE_SINGLE_BLOG,
  ALL_BLOGS_CURRENT_PAGE,
  TOTAL_BLOGS_PAGES,
  GET_ALL_PRIZES,
  PRIZES_CURRENT_PAGE,
  TOTAL_PRIZES_PAGES,
  REMOVE_PRIZE,
  NOTIFICATIONS_CURRENT_PAGE,
  GET_ALL_NOTIFICATIONS,
  TOTAL_NOTIFICATIONS_PAGES,
  GET_SINGLE_PRIZE,
  GET_ALL_POINTS,
  POINTS_CURRENT_PAGE,
  TOTAL_POINTS_PAGES,
  GET_ALL_PURCHASES,
  PURCHASES_CURRENT_PAGE,
  PURCHASES_TOTAL_PAGES,
  GET_SINGLE_PURCHASE,
  GET_ALL_POINTS_BANK,
  POINTS_BANK_CURRENT_PAGE,
  TOTAL_POINTS_BANK_PAGES,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allBlogs: [],
  blogsTotalPages: 0,
  blogsCurrentPage: 1,
  prizes: [],
  prize: null,
  prizesTotalPage: 0,
  prizesCurrentPage: 1,
  notifications: [],
  notificationsCurrentPage: 1,
  notificationsTotalPage: 0,
  points: [],
  pointsCurrentPage: 1,
  pointsTotalPages: 0,
  purchaseList: [],
  purchasesCurrentPage: 1,
  purchasesTotalPages: 0,
  singlePurchase: null,
  pointsBank: [],
  pointsBankCurrentPage: 1,
  pointsBankTotalPages: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_BLOGS: {
      return {
        ...state,
        allBlogs: action.payload,
      };
    }
    case ALL_BLOGS_CURRENT_PAGE: {
      return {
        ...state,
        blogsCurrentPage: action.payload,
      };
    }
    case TOTAL_BLOGS_PAGES: {
      return {
        ...state,
        blogsTotalPages: action.payload,
      };
    }
    case ADD_NEW_BLOG: {
      return {
        ...state,
        allBlogs: [action.payload, ...state.allBlogs],
      };
    }
    case REMOVE_SINGLE_BLOG: {
      return {
        ...state,
        allBlogs: state.allBlogs.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case REMOVE_PRIZE: {
      return {
        ...state,
        prizes: state.prizes.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case GET_ALL_PRIZES: {
      return {
        ...state,
        prizes: action.payload,
      };
    }
    case GET_SINGLE_PRIZE: {
      return {
        ...state,
        prize: action.payload,
      };
    }
    case PRIZES_CURRENT_PAGE: {
      return {
        ...state,
        prizesCurrentPage: action.payload,
      };
    }
    case TOTAL_PRIZES_PAGES: {
      return {
        ...state,
        prizesTotalPage: action.payload,
      };
    }
    case GET_ALL_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload,
      };
    }
    case NOTIFICATIONS_CURRENT_PAGE: {
      return {
        ...state,
        notificationsCurrentPage: action.payload,
      };
    }
    case TOTAL_NOTIFICATIONS_PAGES: {
      return {
        ...state,
        notificationsTotalPage: action.payload,
      };
    }
    case GET_ALL_POINTS: {
      return {
        ...state,
        points: action.payload,
      };
    }
    case POINTS_CURRENT_PAGE: {
      return {
        ...state,
        pointsCurrentPage: action.payload,
      };
    }
    case TOTAL_POINTS_PAGES: {
      return {
        ...state,
        pointsTotalPages: action.payload,
      };
    }
    case GET_ALL_POINTS_BANK: {
      return {
        ...state,
        pointsBank: action.payload,
      };
    }
    case POINTS_BANK_CURRENT_PAGE: {
      return {
        ...state,
        pointsBankCurrentPage: action.payload,
      };
    }
    case TOTAL_POINTS_BANK_PAGES: {
      return {
        ...state,
        pointsBankTotalPages: action.payload,
      };
    }
    case GET_ALL_PURCHASES: {
      return {
        ...state,
        purchaseList: action.payload,
      };
    }
    case PURCHASES_CURRENT_PAGE: {
      return {
        ...state,
        purchasesCurrentPage: action.payload,
      };
    }
    case PURCHASES_TOTAL_PAGES: {
      return {
        ...state,
        purchasesTotalPages: action.payload,
      };
    }
    case GET_SINGLE_PURCHASE: {
      return {
        ...state,
        singlePurchase: action.payload,
      };
    }
    default:
      return state;
  }
};
